angular.module('unica_partner.partner_controllers', [])

.controller('PartnerBasicController',
	function(
		$rootScope, $scope
	) {

	$scope.forms = {};

	$scope.changePartnerAvatar = function() {
		$rootScope.partnerData.avatar_changed = true;
	};

});